import React,{useRef,useEffect,useState} from 'react';
import emailjs from '@emailjs/browser';
import axios from 'axios';
import '../auth/auth.css';
import { useNavigate } from 'react-router-dom';


const baseUrl="https://daily-blog-backend.onrender.com/";
// const baseUrl = "http://localhost:1337/";

const ForgotPassword = () => {
    const navigate=useNavigate();
    const [otp, setOtp] = useState(0);
    const [enteredOtp, setEnteredOtp] = useState(0);
    const [username, setUsername] = useState("");
    const [password,setPassword]=useState({
        newPass:"",
        cnfPass:""
    });
    useEffect(() => {
        document.title = "Reset Password | Daily Blogs"
        let otp = Math.floor(Math.random() * 10000);
        if(otp<1000) otp *= 10;
        setOtp(otp);
    }, []);
    const form = useRef();

    // console.log(otp, parseInt(enteredOtp));

    const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_so8yjoa', 'template_u2hano5', form.current, 'EBHJ2z_9_SVD6BAuP')
      .then((result) => {
          if(result.text==="OK"){
            window.alert("OTP is sent successfully.");
            // navigate('/');
          }
      }, (error) => {
          console.log(error.text);
      });
    }
    function handleClick1(){
        document.querySelector('.sendOtp').style.display='none';
        document.querySelector('.validatePassword').style.display="block";
    }
    function handleClick2(){
        if(String(otp) === String(enteredOtp)){
            // console.log("success");
            document.querySelector('.validatePassword').style.display="none";
            document.querySelector('.setPassword').style.display="block";
        }
    }
    function handleClick3(){
        if(password.newPass===password.cnfPass){
            alert("Success !!");
            axios.post(baseUrl+"updatePassword",{username,password}).then((res)=>{
                if(res.data.success===true){
                    navigate("/login");
                }
            })
        }else{
            alert("Password not matched !");
        }
    }
    //-----------------------------storing password------------------
    function handleChange(e){
        const {name,value}=e.target;
        console.log(name,value);
        setPassword(prev=>{
            if(name==="newPass"){
                return {
                    newPass:value,
                    cnfPass:prev.cnfPass
                }
            }else{
                return{
                    newPass:prev.newPass,
                    cnfPass:value
                }
            }
        });
    }
    // console.log(password);
    return (
      <div className="contact-container">
        <div className='sendOtp'>
            <form ref={form} onSubmit={sendEmail}>
                <h1>Reset Password</h1>
                <div className="input-element" style={{display:"none"}}>
                <label>Name</label><br />
                <input type="text" name="user_name" value={"User"}  placeholder='Enter Your Name...' required/><br />
                </div>
                <div className="input-element" >
                <label style={{marginBottom:"10px"}}>Enter Regestered Email</label><br />
                <input type="email" name="user_email" placeholder='Enter Email...' onChange={(e)=>setUsername(e.target.value)} required style={{marginTop:"10px"}}/><br />
                </div>
                <div className="input-element" style={{display:"none"}}>
                {/* <label>Message</label><br /> */}
                <textarea  name="message" value={`Your otp is ${otp}`} placeholder='Type Message...' rows={6} required/><br />
                </div>
            <div className="input-elemnt">
                <input type="submit" onClick={handleClick1} value="Send" />
            </div>
            </form>
        </div>
        <div className="validatePassword" style={{display:"none"}} >
            <div className="inner">
            <h1>Validate OTP</h1>
            <label htmlFor="validateOTP" style={{color:"green"}}>OTP is sent successfully</label><br />
            <input type="number" name='validateOTP' onChange={(e)=>{setEnteredOtp(e.target.value)}} placeholder='Enter OTP ...' /><br />
            <button onClick={handleClick2}>Verify</button>
            </div>
        </div>
        <div className="setPassword" style={{display:"none"}}>
            <div className="inner">
                <h1>Create New Password</h1>
                <label htmlFor="newPass">New Password</label><br />
                <input type="password" name='newPass' onChange={handleChange} placeholder='Enter new Password' autoComplete='off'/><br />
                <label htmlFor="cnfNewPass">Confirm New Password</label><br />
                <input type="password" name='cnfPass' onChange={handleChange} placeholder='Confirm new Password' autoComplete='off' /><br />
                <button onClick={handleClick3}>Update Password</button>
            </div>
        </div>
    </div>
    );
}

export default ForgotPassword;
